(() => {
  const root = document.querySelector('[data-alpha-search-types]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const panel = root.querySelector('[data-search-resource-panel]');
  const buttons = [...root.querySelectorAll('[data-search-type]')];
  const native = [...document.querySelectorAll('results-list')];
  let selected = 'product', controller;
  const picker = root.querySelector('[data-search-page-size]');
  let perPage = [12,24,36].includes(Number(root.dataset.pageSize)) ? Number(root.dataset.pageSize) : 24;
  let collectionLimit = 10;
  picker.value = String(perPage);
  function configurePicker(type) {
    const choices = type === 'collection' ? [5,10] : [12,24,36];
    picker.replaceChildren(...choices.map(n => { const option = document.createElement('option'); option.value = String(n); option.textContent = String(n); return option; }));
    picker.value = String(type === 'collection' ? collectionLimit : perPage);
  }
  function productPage() {
    const url = new URL(location.href);
    url.searchParams.set('view', 'alpha-search-' + perPage);
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    location.assign(url.href);
  }
  const cache = new Map();
  function status(message) { const p = document.createElement('p'); p.className = 'alpha-search-status'; p.textContent = message; panel.replaceChildren(p); }
  async function select(type, pageURL) {
    controller?.abort();
    selected = type;
    configurePicker(type);
    buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.searchType === type)));
    native.forEach(el => { el.hidden = type !== 'product'; el.style.display = type === 'product' ? '' : 'none'; });
    panel.hidden = type === 'product';
    if (type === 'product') { if (Number(root.dataset.pageSize || 24) !== perPage) productPage(); panel.removeAttribute('aria-busy'); return; }
    const url = new URL(pageURL || root.dataset.searchUrl, location.origin);
    url.searchParams.set('q', root.dataset.query);
    url.searchParams.set('section_id', 'alpha-search-resources');
    if (type === 'collection') {
      url.pathname = root.dataset.searchUrl.replace(/\/$/, '') + '/suggest';
      url.searchParams.set('resources[type]', 'collection');
      url.searchParams.set('resources[limit]', String(collectionLimit));
    } else { url.searchParams.set('type', type); url.searchParams.set('view', 'alpha-search-' + perPage); }
    const key = url.href;
    if (cache.has(key)) { panel.innerHTML = cache.get(key); return; }
    controller = new AbortController();
    panel.setAttribute('aria-busy', 'true'); status(root.dataset.loading);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('#shopify-section-alpha-search-resources');
      if (!content) throw Error('Search section missing');
      cache.set(key, content.innerHTML);
      if (selected === type) panel.innerHTML = content.innerHTML;
    } catch (error) { if (error.name !== 'AbortError' && selected === type) status(root.dataset.error); }
    finally { if (selected === type) panel.removeAttribute('aria-busy'); }
  }
  buttons.forEach(b => b.addEventListener('click', () => select(b.dataset.searchType)));
  picker.addEventListener('change', () => {
    if (selected === 'collection') { collectionLimit = Number(picker.value); select(selected); }
    else { perPage = Number(picker.value); if (selected === 'product') productPage(); else select(selected); }
  });
  const initialType = new URL(location.href).searchParams.get('type');
  if (['page', 'article'].includes(initialType)) select(initialType);
  panel.addEventListener('click', event => { const a = event.target.closest('.alpha-search-pagination a'); if (a) { event.preventDefault(); select(selected, a.href); } });
})();
